import THEMES from "../../constants/themes";
import axios from "axios/dist/axios";
import Vue from "vue";

const defaultState = {
    theme: THEMES.LIGHT.VALUE,

    guiThemeColorLight: THEMES.LIGHT.PRIMARY_COLOR,
    guiThemeColorDark: THEMES.DARK.PRIMARY_COLOR,
    guiThemeColorLightHighContrast: THEMES.LIGHT_HIGH_CONTRAST.PRIMARY_COLOR,
    guiThemeColorDarkHighContrast: THEMES.DARK_HIGH_CONTRAST.PRIMARY_COLOR,

    guiThemeWarningColorLight: THEMES.LIGHT.WARNING_COLOR,
    guiThemeWarningColorDark: THEMES.DARK.WARNING_COLOR,

    currentGuiThemeColor: THEMES.LIGHT.PRIMARY_COLOR,
    currentGuiThemeWarningColor: THEMES.LIGHT.WARNING_COLOR,

    isDarkTheme: false,
    isHighContrast: false,

    themeClass: THEMES.LIGHT.CLASS,

    themeList: [
    {
        value: THEMES.LIGHT.VALUE,
        name: THEMES.LIGHT.NAME
    },
    {
        value: THEMES.DARK.VALUE,
        name: THEMES.DARK.NAME
    },
    {
        value: THEMES.LIGHT_HIGH_CONTRAST.VALUE,
        name: THEMES.LIGHT_HIGH_CONTRAST.NAME
    },
    {
        value: THEMES.DARK_HIGH_CONTRAST.VALUE,
        name: THEMES.DARK_HIGH_CONTRAST.NAME
    }
]
};

const state = {
    theme:                          defaultState.theme,
    guiThemeColorLight:             defaultState.guiThemeColorLight,
    guiThemeColorDark:              defaultState.guiThemeColorDark,
    guiThemeColorLightHighContrast: defaultState.guiThemeColorLightHighContrast,
    guiThemeColorDarkHighContrast:  defaultState.guiThemeColorDarkHighContrast,
    guiThemeWarningColorLight:      defaultState.guiThemeWarningColorLight,
    guiThemeWarningColorDark:       defaultState.guiThemeWarningColorDark,
    currentGuiThemeColor:           defaultState.currentGuiThemeColor,
    currentGuiThemeWarningColor:    defaultState.currentGuiThemeWarningColor,
    isDarkTheme:                    defaultState.isDarkTheme,
    isHighContrast:                 defaultState.isHighContrast,
    themeClass:                     defaultState.themeClass,
    themeList:                      defaultState.themeList
};

const getters = {
    getTheme:                           state => state.theme,
    getGuiThemeColorLight:              state => state.guiThemeColorLight,
    getGuiThemeColorDark:               state => state.guiThemeColorDark,
    getGuiThemeColorLightHighContrast:  state => state.guiThemeColorLightHighContrast,
    getGuiThemeColorDarkHighContrast:   state => state.guiThemeColorDarkHighContrast,
    getCurrentGuiThemeColor:            state => state.currentGuiThemeColor,
    getIsDarkTheme:                     (state) => {
        return (state.theme === THEMES.DARK.VALUE || state.theme === THEMES.DARK_HIGH_CONTRAST.VALUE) ? true : false;
    },
    getIsHighContrast:                  (state) => {
        return (state.theme === THEMES.LIGHT_HIGH_CONTRAST.VALUE || state.theme === THEMES.DARK_HIGH_CONTRAST.VALUE) ? true : false;
    },
    getThemeClass:                      state => state.themeClass,
    getThemeList:                       state => state.themeList,

    /*
    * Useful functions to use in the application.
    * */

    getTransformedCookie: (state, getters) => {
        return (oldCookieValue) => {
            switch (oldCookieValue) {
                case THEMES.LIGHT.CLASS:
                    return THEMES.LIGHT.VALUE;
                case THEMES.DARK.CLASS:
                    return THEMES.DARK.VALUE;
                case THEMES.LIGHT_HIGH_CONTRAST.CLASS:
                    return THEMES.LIGHT_HIGH_CONTRAST.VALUE;
                case THEMES.DARK_HIGH_CONTRAST.CLASS:
                    return THEMES.DARK_HIGH_CONTRAST.VALUE;
                default:
                    return THEMES.LIGHT.VALUE;
            }
        }
    },

    // We use this function to extract the decision item color based on the current theme
    getDecisionItemColor: (state, getters) => {

        const isDarkTheme = getters.getIsDarkTheme;

        return (decisionItem) => {
            if (decisionItem == null) {
                return null;
            }
            // The decision Item has a dark color set if the property is set and the property is not an empty string
            const hasColorDark = (decisionItem.colorDark != null) && (typeof decisionItem.colorDark === 'string' && decisionItem.colorDark !== '');
            if (isDarkTheme === true && hasColorDark) {
                return decisionItem.colorDark;
            }
            else {
                return decisionItem.color;
            }
        }
    },
};

const actions = {
    /**
     * Reads the cookies that are set for theme and contrast mode and sets the app accordingly
     * */
    detectTheme({dispatch, commit, getters}) {
        // We get the theme cookie
        let themeCookie = this._vm.$UtilitiesPlugin.getCookie('theme');
        let themeToBeSelected = THEMES.LIGHT.VALUE; // By default we use the light theme.

        // We first check the high contrast match media to see if the user has set the system/browser to high contrast to match our high contrast
        if (window.matchMedia && (window.matchMedia('(prefers-contrast: more)').matches || (window.matchMedia('(forced-colors: active)').matches))) {
            if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
                themeToBeSelected = THEMES.DARK_HIGH_CONTRAST.VALUE;
            }
            else {
                themeToBeSelected = THEMES.LIGHT_HIGH_CONTRAST.VALUE;
            }
        }

        // We set the theme according to the set cookie
        else if (themeCookie !== undefined) {
            // If the cookie coresponds with a theme we set the theme
            if (themeCookie === THEMES.LIGHT.VALUE || themeCookie === THEMES.DARK.VALUE || themeCookie === THEMES.LIGHT_HIGH_CONTRAST.VALUE || themeCookie === THEMES.DARK_HIGH_CONTRAST.VALUE) {
                themeToBeSelected = themeCookie;
            }
            // If the cookie does not correspond with a theme we transform the cookie to a theme
            else {
                // We translate the old cookie value to the new cookie value
                themeToBeSelected = getters.getTransformedCookie(themeCookie);
            }
        }
        else {
            // If there is no cookie set for the theme we choose the theme from the OS setting.
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                // Is dark mode
                themeToBeSelected = THEMES.DARK.VALUE;
            }
            else {
                // Is light mode
                themeToBeSelected = THEMES.LIGHT.VALUE;
            }
        }
        // We select the corresponding theme.
        dispatch('selectTheme', {newThemeValue: themeToBeSelected});
    },

    setGuiThemeColors({commit}, colorsObject) {
      // This function sets the gui theme colors from the /applicationData
      if (colorsObject != null) {
          if (colorsObject['GUI_THEME_COLOR'] != null) {
              commit('setGuiThemeColorLight', colorsObject['GUI_THEME_COLOR']);
          }
          if (colorsObject['GUI_THEME_COLOR_DARK'] != null) {
              commit('setGuiThemeColorDark', colorsObject['GUI_THEME_COLOR_DARK']);
          }

          if (colorsObject['GUI_THEME_WARNING_COLOR'] != null) {
              commit('setGuiThemeWarningColorLight', colorsObject['GUI_THEME_WARNING_COLOR']);
          }
          if (colorsObject['GUI_THEME_WARNING_COLOR_DARK'] != null) {
              commit('setGuiThemeWarningColorDark', colorsObject['GUI_THEME_WARNING_COLOR_DARK']);
          }
      }
    },

    /**
     * Creates a list of theme objects to be used in GUI
     * */
    createThemeList({commit}) {
        let themeList = [
            {
                value: THEMES.LIGHT.VALUE,
                name: this._vm.$text('api.theme.light'),

            },
            {
                value: THEMES.DARK.VALUE,
                name: this._vm.$text('api.theme.dark')
            },
            {
                value: THEMES.LIGHT_HIGH_CONTRAST.VALUE,
                name: this._vm.$text('api.theme.light.highContrast'),

            },
            {
                value: THEMES.DARK_HIGH_CONTRAST.VALUE,
                name: this._vm.$text('api.theme.dark.highContrast'),
            }
        ];
        commit('setThemeList', themeList);
    },

    /**
     * Removes the previous classes when changing the theme
     * */
    setCSSVariables() {
        // We set the primary color of the vue theme
        Vue.prototype.$vuetify.theme.primary = state.currentGuiThemeColor;
        // We get the <html> tag and we set the --primary-color css variable
        let htmlElement = document.documentElement;
        if (!window.matchMedia('(forced-colors: active)').matches) {
            htmlElement.style.setProperty('--primary-color', state.currentGuiThemeColor);
            htmlElement.style.setProperty('--warning-color', state.currentGuiThemeWarningColor)
        }

    },

    /**
     * Updates the GUI_THEME_COLORS of the application
     * @param dispatch
     * @param appProperties the new appProperties
     * */
    updateGuiThemeColors({dispatch}, appProperties) {
        dispatch("setGuiThemeColors", {
            "GUI_THEME_WARNING_COLOR" : appProperties['GUI_THEME_WARNING_COLOR'] || null,
            "GUI_THEME_WARNING_COLOR_DARK":  appProperties['GUI_THEME_WARNING_COLOR_DARK'] || appProperties['GUI_THEME_WARNING_COLOR'] || null,
            "GUI_THEME_COLOR": appProperties['GUI_THEME_COLOR'] || null,
            "GUI_THEME_COLOR_DARK": appProperties['GUI_THEME_COLOR_DARK'] || appProperties['GUI_THEME_COLOR'] || null
        });
        dispatch('detectTheme');
    },

    /**
     * Removes the previous classes when changing the theme
     * */
    cleanThemeClasses() {
        // We extract the rootElement
        let rootElement = document.documentElement;
        rootElement.classList.remove(THEMES.LIGHT.CLASS);
        rootElement.classList.remove(THEMES.DARK.CLASS);
        rootElement.classList.remove(THEMES.LIGHT_HIGH_CONTRAST.CLASS.substring(THEMES.LIGHT_HIGH_CONTRAST.CLASS.indexOf("high--contrast")));
    },

    /**
     * Sets the theme cookie and state value
     * @param commit
     * @param dispatch
     * @param getters
     * @param options - an object containing the new theme value and if we call selectTheme from PRO or PFI
     * */
    selectTheme({commit, dispatch}, options) {
        // We set the theme value
        commit('setTheme', options.newThemeValue);

        // We clean the previous classes from the <html> tag
        let rootElement = document.documentElement;
        dispatch('cleanThemeClasses');
        // Set new selected theme's specific class(es) on the <html> tag.
        commit('setThemeClass');
        rootElement.classList.add.apply(rootElement.classList, state.themeClass.split(" "));

        // Find and set the primary color.
        commit('setCurrentGuiThemeColor');
        // Find and set the warning color.
        commit('setCurrentGuiThemeWarningColor');

        dispatch('setCSSVariables');

        // Store selected theme into a cookie, so it will be automatically selected when the user reopens the app.
        this._vm.$UtilitiesPlugin.setCookie('theme', state.theme , 366);

        // Notify the API server about selected theme, but only when the user changes the theme manually.
        // The key `options.newThemeValue.isPFI` is present only when the user selects a theme manually
        // and it's undefined when the theme is automatically selected (on page load).
        if (typeof options.isPFI !== "undefined") {
            let requestParams = {value: ""};
            if (state.theme > 0) {
                requestParams.value = state.theme;
                let requestUrl = (options.isPFI)
                    ? process.env.API_BASE_URL_PATHFINDER + '/setTheme'
                    : process.env.API_BASE_URL + '/setTheme';

                axios.post(requestUrl, requestParams);
            }
        }
    },
};

const mutations = {
    setTheme (state, value) {
        state.theme = value;
    },
    setGuiThemeColorLight (state, value) {
        state.guiThemeColorLight = value;
    },
    setGuiThemeColorDark (state, value) {
        state.guiThemeColorDark = value;
    },
    setGuiThemeWarningColorLight (state, value) {
        state.guiThemeWarningColorLight = value;
    },
    setGuiThemeWarningColorDark (state, value) {
        state.guiThemeWarningColorDark = value;
    },
    setGuiThemeColorLightHighContrast (state, value) {
        state.guiThemeColorLightHighContrast = value;
    },
    setGuiThemeColorDarkHighContrast (state, value) {
        state.guiThemeColorDarkHighContrast = value;
    },
    setCurrentGuiThemeColor(state) {
        switch (state.theme) {
            case THEMES.LIGHT.VALUE:
                state.currentGuiThemeColor = state.guiThemeColorLight;
                break;
            case THEMES.DARK.VALUE:
                state.currentGuiThemeColor = state.guiThemeColorDark;
                break;
            case THEMES.LIGHT_HIGH_CONTRAST.VALUE:
                state.currentGuiThemeColor = state.guiThemeColorLightHighContrast;
                break;
            case THEMES.DARK_HIGH_CONTRAST.VALUE:
                state.currentGuiThemeColor = state.guiThemeColorDarkHighContrast;
                break;
            default:
                state.currentGuiThemeColor = defaultState.currentGuiThemeColor;
        }
    },
    setCurrentGuiThemeWarningColor(state) {
        switch (state.theme) {
            case THEMES.LIGHT.VALUE:
                state.currentGuiThemeWarningColor = state.guiThemeWarningColorLight;
                break;
            case THEMES.DARK.VALUE:
                state.currentGuiThemeWarningColor = state.guiThemeWarningColorDark;
                break;
            case THEMES.LIGHT_HIGH_CONTRAST.VALUE:
                state.currentGuiThemeWarningColor = state.guiThemeWarningColorLight;
                break;
            case THEMES.DARK_HIGH_CONTRAST.VALUE:
                state.currentGuiThemeWarningColor = state.guiThemeWarningColorDark;
                break;
            default:
                state.currentGuiThemeWarningColor = defaultState.guiThemeWarningColorLight;
        }
    },
    setThemeClass(state) {
        switch (state.theme) {
            case THEMES.LIGHT.VALUE:
                state.themeClass = THEMES.LIGHT.CLASS;
                break;
            case THEMES.DARK.VALUE:
                state.themeClass = THEMES.DARK.CLASS;
                break;
            case THEMES.LIGHT_HIGH_CONTRAST.VALUE:
                state.themeClass = THEMES.LIGHT_HIGH_CONTRAST.CLASS;
                break;
            case THEMES.DARK_HIGH_CONTRAST.VALUE:
                state.themeClass = THEMES.DARK_HIGH_CONTRAST.CLASS;
                break;
            default:
                state.themeClass = THEMES.LIGHT.CLASS;
        }
    },
    setThemeList(state, value) {
        state.themeList = value;
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/ThemeStore.js